"use strict";

require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find-index.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/es.function.name.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _button = require("@citrus/button");
var _layout = require("@citrus/layout");
var _progressBar = require("@citrus/progress-bar");
var _reactQuestion = _interopRequireDefault(require("@pcty/react-question"));
var _zeroState = require("@citrus/zero-state");
var _PctySurvey = require("./PctySurvey.Common");
var _PctySurvey2 = require("./PctySurvey.Constants");
var _PctySurvey3 = require("./PctySurvey.ConditionalDisplay");
var _questionBuilder = require("@pcty/question-builder");
var _utilsValue = require("@pcty/utils-value");
var _utilsArray = require("@pcty/utils-array");
var _findIndex = _interopRequireDefault(require("lodash/findIndex"));
var _lodash = _interopRequireDefault(require("lodash.isequal"));
var _lodash2 = _interopRequireDefault(require("lodash.shuffle"));
var _lodash3 = _interopRequireDefault(require("lodash.sortby"));
var _uuid = _interopRequireDefault(require("uuid"));
require("./index.css");
var _div, _p;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var PctySurvey = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PctySurvey, _Component);
  var _super = _createSuper(PctySurvey);
  function PctySurvey(props) {
    var _this;
    (0, _classCallCheck2.default)(this, PctySurvey);
    _this = _super.call(this, props);
    var questionOrder = props.settings.questionsInOrder ? props.questions.map(function (x) {
      return x.id;
    }) : (0, _lodash2.default)(props.questions).map(function (x) {
      return x.id;
    });
    var question = getQuestion(props.questions, questionOrder, 0);
    var questionCount = props.questions.filter(function (x) {
      return _this.isQuestionTypeAnswerable(x);
    }).length;
    var pages = (0, _PctySurvey.getPages)(props.questions);
    var displayedQuestions = _this.getQuestionsToDisplay(undefined, props.questions);
    var questionNumberPageMap = _this.getQuestionNumberPageMap(displayedQuestions);
    _this.state = {
      questionOrder: questionOrder,
      totalQuestions: questionCount,
      questionNumber: 0,
      // used only for oneQuestionAtATime
      questionIndex: -1,
      // used only for oneQuestionAtATime
      completedQuestions: [],
      // used only for oneQuestionAtATime
      questionNumberPageMap: questionNumberPageMap,
      question: question,
      pages: pages,
      activePageId: pages[0] || undefined,
      response: (0, _PctySurvey.getResponse)(question, props.responses),
      getComment: (0, _PctySurvey.getComment)(question, props.responses),
      validationErrors: []
    };
    _this.onClickPreviousQuestion = _this.onClickPreviousQuestion.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickNextQuestion = _this.onClickNextQuestion.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickPreviousPage = _this.onClickPreviousPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickNextPage = _this.onClickNextPage.bind((0, _assertThisInitialized2.default)(_this));
    _this.onSetActivePage = _this.onSetActivePage.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOnResponse = _this.handleOnResponse.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleOnComment = _this.handleOnComment.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickComplete = _this.onClickComplete.bind((0, _assertThisInitialized2.default)(_this));
    _this.onClickStart = _this.onClickStart.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(PctySurvey, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;
      if (!(0, _lodash.default)(this.props.responses, nextProps.responses)) {
        this.setState({
          response: (0, _PctySurvey.getResponse)(this.state.question, nextProps.responses)
        });
      }
      var isEqualQuestions = function isEqualQuestions() {
        if (_this2.props.settings.questionsInOrder) {
          return (0, _lodash.default)(_this2.props.questions, nextProps.questions);
        }
        var current = (0, _lodash3.default)(_this2.props.questions.map(function (x) {
          return {
            id: x.id,
            correct: x.correct
          };
        }), function (z) {
          return z.id;
        });
        var next = (0, _lodash3.default)(nextProps.questions.map(function (x) {
          return {
            id: x.id,
            correct: x.correct
          };
        }), function (z) {
          return z.id;
        });
        return (0, _lodash.default)(current, next);
      };
      if (!isEqualQuestions()) {
        if (this.props.settings.questionsInOrder) {
          var questionOrder = this.props.settings.questionsInOrder ? nextProps.questions.map(function (x) {
            return x.id;
          }) : (0, _lodash2.default)(nextProps.questions).map(function (x) {
            return x.id;
          });
          var question = getQuestion(nextProps.questions, questionOrder, 0);
          var questionCount = nextProps.questions.filter(function (x) {
            return _this2.isQuestionTypeAnswerable(x);
          }).length;
          var pages = (0, _PctySurvey.getPages)(nextProps.questions);
          var displayedQuestions = this.getQuestionsToDisplay(undefined, nextProps.questions);
          var questionNumberPageMap = this.getQuestionNumberPageMap(displayedQuestions);
          var newState = {
            questionOrder: questionOrder,
            totalQuestions: questionCount,
            questionNumber: 0,
            // used only for oneQuestionAtATime
            questionIndex: -1,
            // used only for oneQuestionAtATime
            completedQuestions: [],
            // used only for oneQuestionAtATime
            questionNumberPageMap: questionNumberPageMap,
            // {question:{}, number: undefined }
            question: question,
            pages: pages,
            activePageId: pages[0] || undefined,
            response: (0, _PctySurvey.getResponse)(question, nextProps.responses || []),
            validationErrors: []
          };
          this.setState(_objectSpread({}, newState));
        } else {
          this.setState({
            question: getQuestion(nextProps.questions, this.state.questionOrder, this.state.questionIndex)
          });
        }
      }
    }
  }, {
    key: "onClickStart",
    value: function onClickStart() {
      var newQuestionIndex = 0;
      var question = getQuestion(this.props.questions, this.state.questionOrder, newQuestionIndex);
      var questionNumber = this.getQuestionNumber(question);
      this.setState({
        questionIndex: newQuestionIndex,
        question: question,
        questionNumber: questionNumber,
        response: (0, _PctySurvey.getResponse)(question, this.props.responses)
      });
      document.activeElement.blur();
    }
  }, {
    key: "onClickPreviousQuestion",
    value: function onClickPreviousQuestion() {
      if (this.state.questionIndex === 0) return;
      var newQuestionIndex = this.state.questionIndex - 1;
      var question = getQuestion(this.props.questions, this.state.questionOrder, newQuestionIndex);

      // filter the questions by conditional logic if present; if question cannot be displayed, goto prev one
      while (newQuestionIndex < this.props.questions.length && !(0, _utilsValue.isNullOrEmpty)(question.visibleIf) && !(0, _PctySurvey3.isConditionalCriteriaMet)(this.props.questions, this.props.responses, question.visibleIf)) {
        newQuestionIndex -= 1;
        question = getQuestion(this.props.questions, this.state.questionOrder, newQuestionIndex);
      }
      var questionNumber = this.getQuestionNumber(question);
      this.setState({
        questionIndex: newQuestionIndex,
        question: question,
        questionNumber: questionNumber,
        response: (0, _PctySurvey.getResponse)(question, this.props.responses)
      });
      document.activeElement.blur();
    }
  }, {
    key: "onClickNextQuestion",
    value: function onClickNextQuestion() {
      if (this.state.questionIndex + 1 === this.props.questions.length) return;
      var newQuestionIndex = this.state.questionIndex + 1;
      var question = getQuestion(this.props.questions, this.state.questionOrder, newQuestionIndex);

      // filter the questions by conditional logic if present; if question cannot be displayed, goto next one
      while (newQuestionIndex < this.props.questions.length && !(0, _utilsValue.isNullOrEmpty)(question.visibleIf) && !(0, _PctySurvey3.isConditionalCriteriaMet)(this.props.questions, this.props.responses, question.visibleIf)) {
        newQuestionIndex += 1;
        question = getQuestion(this.props.questions, this.state.questionOrder, newQuestionIndex);
      }
      var questionNumber = this.getQuestionNumber(question);
      this.setState({
        questionIndex: newQuestionIndex,
        completedQuestions: this.isQuestionTypeAnswerable(this.state.question) && this.state.completedQuestions.indexOf(this.state.question.id) === -1 ? [].concat((0, _toConsumableArray2.default)(this.state.completedQuestions), [this.state.question.id]) : this.state.completedQuestions,
        question: question,
        questionNumber: questionNumber,
        response: (0, _PctySurvey.getResponse)(question, this.props.responses)
      });
      document.activeElement.blur();
    }
  }, {
    key: "onClickPreviousPage",
    value: function onClickPreviousPage() {
      var _this3 = this;
      var currentDisplayedQuestions = this.getQuestionsToDisplay(this.state.activePageId);
      var validationErrors = this.validateQuestions(currentDisplayedQuestions);
      this.setState({
        validationErrors: validationErrors
      });
      var firstPageIndex = 0;
      var activePageIndex = this.state.pages.findIndex(function (x) {
        return x === _this3.state.activePageId;
      });
      if (activePageIndex === firstPageIndex) return;
      var newPageIndex = activePageIndex - 1;
      var activePageId = this.state.pages[newPageIndex];

      // process conditionals and get latest questionNumberPageMap
      var activeQuestions = this.getQuestionsToDisplay(undefined, this.props.questions);
      var questionNumberPageMap = this.getQuestionNumberPageMap(activeQuestions);

      // filter the questions by pageId logic if present; if no questions, goto prev one
      var questionsToDisplay = this.getQuestionsOnPage(activePageId, questionNumberPageMap);
      while (questionsToDisplay.length === 0 && newPageIndex > 0) {
        newPageIndex -= 1;
        activePageId = this.state.pages[newPageIndex];
        questionsToDisplay = this.getQuestionsOnPage(activePageId, questionNumberPageMap);
      }
      this.setState({
        activePageId: activePageId,
        questionNumberPageMap: questionNumberPageMap
      });
    }
  }, {
    key: "onClickNextPage",
    value: function onClickNextPage() {
      var _this4 = this;
      var currentDisplayedQuestions = this.getQuestionsToDisplay(this.state.activePageId);
      var validationErrors = this.validateQuestions(currentDisplayedQuestions);
      this.setState({
        validationErrors: validationErrors
      });

      // don't allow them to move on if errors
      if (validationErrors.length > 0) return;
      var lastPageIndex = this.state.pages.length - 1;
      var activePageIndex = this.state.pages.findIndex(function (x) {
        return x === _this4.state.activePageId;
      });
      if (activePageIndex === lastPageIndex) return;
      var newPageIndex = activePageIndex + 1;
      var activePageId = this.state.pages[newPageIndex];

      // process conditionals and get latest questionNumberPageMap
      var activeQuestions = this.getQuestionsToDisplay(undefined, this.props.questions);
      var questionNumberPageMap = this.getQuestionNumberPageMap(activeQuestions);

      // filter the questions by pageId logic if present; if no questions, goto next one
      var questionsToDisplay = this.getQuestionsOnPage(activePageId, questionNumberPageMap);
      while (questionsToDisplay.length === 0 && newPageIndex < this.state.pages.length) {
        newPageIndex += 1;
        if (this.state.pages[newPageIndex]) {
          activePageId = this.state.pages[newPageIndex];
          questionsToDisplay = this.getQuestionsOnPage(activePageId, questionNumberPageMap);
        } else {
          questionsToDisplay = -1; // we passed the last page, so drop out
        }
      }

      this.setState({
        activePageId: activePageId,
        questionNumberPageMap: questionNumberPageMap
      });
    }
  }, {
    key: "handleOnResponse",
    value: function handleOnResponse(id, response) {
      if (this.props.previewOnly) return;
      var allVisibleQuestionsCount = this.getAllVisibleQuestionsCount(this.state.questionNumberPageMap);
      var question = this.props.questions.find(function (x) {
        return x.id === id;
      });
      var typeId = question ? question.typeId : null;
      var comment = (0, _PctySurvey.getComment)(question, this.props.responses);

      // only process conditional displays if the user changed the value of a potential trigger!
      var processConditionalDisplays = (0, _PctySurvey3.isTriggerTypeQuestion)(typeId);
      if (processConditionalDisplays) {
        // process conditionals and get the latest questionNumberPageMap
        var newResponse = {
          id: id,
          response: response
        };
        var activeQuestions = this.getQuestionsToDisplay(undefined, this.props.questions, newResponse);
        var questionNumberPageMap = this.getQuestionNumberPageMap(activeQuestions);
        if (!(0, _lodash.default)(this.state.questionNumberPageMap, questionNumberPageMap)) {
          this.setState({
            questionNumberPageMap: questionNumberPageMap
          });
          allVisibleQuestionsCount = this.getAllVisibleQuestionsCount(questionNumberPageMap);
        }
      }
      if (question.allowComments) {
        this.props.onResponse(id, {
          id: id,
          typeId: typeId,
          committed: false,
          comment: comment,
          response: response
        }, allVisibleQuestionsCount); // Only add comment info to questions that we allow comments.
      } else {
        this.props.onResponse(id, {
          id: id,
          typeId: typeId,
          committed: false,
          response: response
        }, allVisibleQuestionsCount);
      }
    }
  }, {
    key: "handleOnComment",
    value: function handleOnComment(id, comment) {
      if (this.props.previewOnly) return;
      var allVisibleQuestionsCount = this.getAllVisibleQuestionsCount(this.state.questionNumberPageMap);
      var question = this.props.questions.find(function (x) {
        return x.id === id;
      });
      var typeId = question ? question.typeId : null;
      var response = (0, _PctySurvey.getResponse)(question, this.props.responses);
      this.props.onComment(id, {
        id: id,
        typeId: typeId,
        committed: false,
        response: response,
        comment: comment
      }, allVisibleQuestionsCount);
    }
  }, {
    key: "getAllVisibleQuestionsCount",
    value: function getAllVisibleQuestionsCount(questionNumberPageMap) {
      if (!questionNumberPageMap) return this.props.questions.length;
      var questionItems = questionNumberPageMap.filter(function (x) {
        return x.number > 0;
      });
      return questionItems.length;
    }
  }, {
    key: "validateSingleQuestion",
    value: function validateSingleQuestion(question, response) {
      var validationState = getDefaultValidationState();
      if (!question || !this.isQuestionTypeAnswerable(question)) return validationState;

      // set any props that were pulled over directly from the QuestionBuilder
      if ('answerRequired' in question) question.required = question.answerRequired;
      if ('displayFormat' in question) question.columns = question.displayFormat;
      if ('displayOrder' in question) question.sortOrder = question.displayOrder.value;
      if ('questionPlaceholder' in question) question.placeholder = question.questionPlaceholder;
      if (question.required) {
        if (!response || response.length === 0) {
          _PctySurvey2.validationErrorDefaultCaptions;
          validationState = {
            valid: false,
            errorMessage: this.getCaption(_PctySurvey2.validationErrorKeys.answerRequired, _PctySurvey2.validationErrorDefaultCaptions.answerRequired)
          };
        }
      }
      if (response && response.length > 0) {
        if (question.otherQuestion && question.otherQuestion.enabled) {
          var otherOption = response.find(function (x) {
            return x.optionId === "otherOption";
          });
          if (otherOption && (0, _utilsValue.isNullOrEmpty)(otherOption.value)) {
            validationState = {
              valid: false,
              errorMessage: this.getCaption(_PctySurvey2.validationErrorKeys.otherValueRequired, _PctySurvey2.validationErrorDefaultCaptions.otherValueRequired)
            };
          }
        }

        // ConstantSum: if EnforceTargetSum is set, the numbers must add up to that target
        if (question.typeId === _questionBuilder.QUESTION_TYPE.constantSum) {
          if (question.enforceTargetSum) {
            var currentSum = response.reduce(function (prev, cur) {
              return prev + parseInt(cur.value || 0);
            }, 0);
            if (question.targetSumValue !== currentSum) {
              var sumMustEqual = this.getCaption(_PctySurvey2.validationErrorKeys.sumMustEqual, _PctySurvey2.validationErrorDefaultCaptions.sumMustEqual);
              validationState = {
                valid: false,
                errorMessage: sumMustEqual.replace("TARGET_SUM", "".concat(question.targetSumValue))
              };
            }
          }
          if (question.minimumValue || question.maximumValue) {
            if (question.minimumValue && question.maximumValue) {
              var invalidCount = response.reduce(function (prev, cur) {
                var intValue = cur.value ? parseInt(cur.value) : undefined;
                var invalid = parseInt(question.minimumValue) > intValue || parseInt(question.maximumValue) < intValue ? 1 : 0;
                return prev + invalid;
              }, 0);
              if (invalidCount > 0) {
                var minAndMaxInputRange = this.getCaption(_PctySurvey2.validationErrorKeys.minAndMaxInputRange, _PctySurvey2.validationErrorDefaultCaptions.minAndMaxInputRange);
                var errorMessage = minAndMaxInputRange.replace("MINIMUM_INPUT", "".concat(question.minimumValue)).replace("MAXIMUM_INPUT", "".concat(question.maximumValue));
                validationState = {
                  valid: false,
                  errorMessage: errorMessage
                };
              }
            } else if (question.minimumValue && !question.maximumValue) {
              var _invalidCount = response.reduce(function (prev, cur) {
                var intValue = cur.value ? parseInt(cur.value) : undefined;
                var invalid = parseInt(question.minimumValue) > intValue ? 1 : 0;
                return prev + invalid;
              }, 0);
              if (_invalidCount > 0) {
                var minimumInputRange = this.getCaption(_PctySurvey2.validationErrorKeys.minimumInputRange, _PctySurvey2.validationErrorDefaultCaptions.minimumInputRange);
                var _errorMessage = minimumInputRange.replace("MINIMUM_INPUT", "".concat(question.minimumValue));
                validationState = {
                  valid: false,
                  errorMessage: _errorMessage
                };
              }
            } else if (!question.minimumValue && question.maximumValue) {
              var _invalidCount2 = response.reduce(function (prev, cur) {
                var intValue = cur.value ? parseInt(cur.value) : undefined;
                var invalid = parseInt(question.maximumValue) < intValue ? 1 : 0;
                return prev + invalid;
              }, 0);
              if (_invalidCount2 > 0) {
                var maximumInputRange = this.getCaption(_PctySurvey2.validationErrorKeys.maximumInputRange, _PctySurvey2.validationErrorDefaultCaptions.maximumInputRange);
                var _errorMessage2 = maximumInputRange.replace("MAXIMUM_INPUT", "".concat(question.maximumValue));
                validationState = {
                  valid: false,
                  errorMessage: _errorMessage2
                };
              }
            }
          }
        }
      }
      return validationState;
    }
  }, {
    key: "validateAndUpdateSingleQuestion",
    value: function validateAndUpdateSingleQuestion(question, response) {
      if (!question) return;
      var validationErrors = (0, _toConsumableArray2.default)(this.state.validationErrors);
      var validationState = this.validateSingleQuestion(question, response);
      var errorIndex = (0, _findIndex.default)(validationErrors, function (x) {
        return x.questionId === question.id;
      });

      // an error for this question already exists, so remove it (it may have changed)
      if (errorIndex > -1) {
        validationErrors = (0, _utilsArray.removeAt)(validationErrors, errorIndex);
      }
      if (!validationState.valid) {
        validationErrors.push({
          questionId: question.id,
          validationState: validationState
        });
      }
      this.setState({
        validationErrors: validationErrors
      });
    }
  }, {
    key: "validateQuestions",
    value: function validateQuestions(questions) {
      var _this5 = this;
      var validationErrors = [];
      if (!questions || questions.length === 0) return validationErrors;
      questions.map(function (question) {
        var response = (0, _PctySurvey.getResponse)(question, _this5.props.responses);
        var validationState = _this5.validateSingleQuestion(question, response);
        if (!validationState.valid) {
          validationErrors.push({
            questionId: question.id,
            validationState: validationState
          });
        }
      });
      return validationErrors;
    }
  }, {
    key: "getValidationError",
    value: function getValidationError(question) {
      var error = getDefaultValidationState();
      if (question && this.state.validationErrors && this.state.validationErrors.length > 0) {
        var questionError = this.state.validationErrors.find(function (x) {
          return x.questionId === question.id;
        });
        if (questionError) {
          error = _objectSpread({}, questionError.validationState);
        }
      }
      return error;
    }
  }, {
    key: "getOnlyDisplayedAnswerResponses",
    value: function getOnlyDisplayedAnswerResponses(responses, questions) {
      var res = [];
      res = responses.filter(function (r) {
        return questions.find(function (q) {
          return r.id === q.id;
        });
      });
      return res;
    }
  }, {
    key: "onClickComplete",
    value: function onClickComplete() {
      // need to validate ALL questions; can have prior required added by other conditionals!
      var allDisplayedQuestions = this.getQuestionsToDisplay();
      var validationErrors = this.validateQuestions(allDisplayedQuestions);
      var scrubbedResponses = this.getOnlyDisplayedAnswerResponses(this.props.responses, allDisplayedQuestions);
      this.setState({
        validationErrors: validationErrors
      });

      // don't allow them to complete if errors
      if (validationErrors.length > 0) return;
      var allVisibleQuestionsCount = this.getAllVisibleQuestionsCount(this.state.questionNumberPageMap);
      this.props.onComplete(this.props.questions, scrubbedResponses, allVisibleQuestionsCount);
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderContainer();
    }
  }, {
    key: "renderZeroState",
    value: function renderZeroState() {
      return _div || (_div = /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12 pcty-type-centeralign pcty-padding-top"
      }, /*#__PURE__*/_react.default.createElement(_zeroState.ZeroState, {
        automationId: "sy-zero-state",
        key: "sy-zero-state",
        type: "insufficientdata",
        message: "There are no questions to display."
      }))));
    }
  }, {
    key: "renderInlineActionArea",
    value: function renderInlineActionArea() {
      var _this6 = this;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-survey-form-action-area"
      }, this.renderActions(actionLocation.INLINE, true), this.props.settings.allowSaveDraft && /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        key: "form-actions-save-draft",
        id: "btn-form-actions-save-draft",
        onClick: function onClick() {
          return _this6.props.onSaveDraft();
        }
      }, this.getCaption("SurveyDetails.saveDraft", "Save Draft")), this.props.settings.allowDecline && /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
        key: "form-actions-decline",
        id: "btn-form-actions-decline",
        disabled: this.props.settings.isOptOutButtonDisabled,
        onClick: function onClick() {
          return _this6.props.onDecline();
        }
      }, this.getCaption("SurveyDetails.optOut", "Opt Out")), this.props.settings.allowCancel && /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
        key: "form-actions-cancel",
        id: "btn-form-actions-cancel",
        onClick: function onClick() {
          return _this6.props.onCancel();
        }
      }, this.getCaption("SurveyDetails.cancel", "Cancel")));
    }
  }, {
    key: "renderContainer",
    value: function renderContainer() {
      var _this7 = this;
      var _renderInlineActionArea = function _renderInlineActionArea() {
        return _this7.props.settings.useInlineActions && !_this7.props.previewOnly ? _this7.renderInlineActionArea() : undefined;
      };
      var answerAllRequired = this.getCaption(_PctySurvey2.validationErrorKeys.answerAllRequired, _PctySurvey2.validationErrorDefaultCaptions.answerAllRequired);
      if (this.props.previewOnly) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.props.questions.length === 0 ? this.renderZeroState() : this.renderAllQuestions());
      }
      if (this.props.settings.oneQuestionAtATime) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !this.props.settings.hideHeader && /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-row"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-col-xs-12"
        }, /*#__PURE__*/_react.default.createElement(_layout.Header, {
          id: "".concat(this.props.id, "-content-header"),
          title: this.props.name,
          renderActionArea: function renderActionArea() {
            return _this7.renderActions(actionLocation.HEADER);
          },
          onBack: this.props.onBack
        }))), this.props.questions.length === 0 ? this.renderZeroState() : this.renderSingleQuestions(), this.state.validationErrors.length > 0 ? /*#__PURE__*/_react.default.createElement("span", {
          className: "pcty-survey-questions"
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: {
            marginLeft: '30px'
          },
          className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
        }, answerAllRequired)) : null, _renderInlineActionArea(), !this.props.settings.hideFooter && /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-row pcty-padding-all"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-col-xs-12 pcty-type-rightalign pcty-border-top pcty-padding-top"
        }, this.renderActions(actionLocation.FOOTER))));
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !this.props.settings.hideHeader && /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, /*#__PURE__*/_react.default.createElement(_layout.Header, {
        id: "".concat(this.props.id, "-content-header"),
        title: this.props.name,
        renderActionArea: function renderActionArea() {
          return _this7.renderActions(actionLocation.HEADER);
        },
        onBack: this.props.onBack
      }))), this.props.questions.length === 0 ? this.renderZeroState() : this.renderAllQuestions(), this.state.validationErrors.length > 0 ? /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-survey-questions"
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          marginLeft: '30px'
        },
        className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
      }, answerAllRequired)) : null, _renderInlineActionArea(), !this.props.settings.hideFooter && /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-padding-bottom pcty-padding-right"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12 pcty-type-rightalign"
      }, this.renderActions(actionLocation.FOOTER))));
    }
  }, {
    key: "renderSplash",
    value: function renderSplash() {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-none pcty-padding-all"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, this.props.renderSplash()));
    }
  }, {
    key: "renderSingleQuestions",
    value: function renderSingleQuestions() {
      if (this.state.questionIndex < 0 && !!this.props.renderSplash) {
        return this.renderSplash();
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.renderProgressBar(), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-none pcty-padding-all pcty-survey-questions"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12",
        disabled: this.props.previewOnly,
        style: {
          minHeight: 275
        }
      }, this.renderQuestion(this.state.question, this.state.response, this.state.comment))));
    }
  }, {
    key: "renderProgressBar",
    value: function renderProgressBar() {
      var _this8 = this;
      if (this.state.questionIndex < this.state.totalQuestions) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-row pcty-margin-none pcty-padding-vertical pcty-border-bottom"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-col-xs-12"
        }, /*#__PURE__*/_react.default.createElement(_progressBar.ProgressBar, {
          visible: true,
          background: true,
          renderHeader: function renderHeader() {
            return /*#__PURE__*/_react.default.createElement("div", null, "".concat(_this8.state.questionNumber, " of ").concat(_this8.state.totalQuestions, " Questions"));
          },
          progress: this.state.completedQuestions.length / this.state.totalQuestions * 100
        })));
      }
      return null;
    }
  }, {
    key: "isQuestionTypeAnswerable",
    value: function isQuestionTypeAnswerable(question) {
      return question && [_questionBuilder.QUESTION_TYPE.title, _questionBuilder.QUESTION_TYPE.paragraph, _questionBuilder.QUESTION_TYPE.video].indexOf(question.typeId) < 0;
    }
  }, {
    key: "getQuestionNumber",
    value: function getQuestionNumber(question) {
      var item = this.state.questionNumberPageMap.find(function (x) {
        return x.question.id === question.id;
      });
      return item ? item.number || 0 : 0;
    }
  }, {
    key: "getQuestionNumberPageMap",
    value: function getQuestionNumberPageMap(questions) {
      var _this9 = this;
      //questionNumberPageMap: [],  // {question:{}, number: undefined }
      var tempMap = [];
      var questionNumber = 0;
      if (questions) {
        questions.map(function (item) {
          if (_this9.isQuestionTypeAnswerable(item)) {
            questionNumber += 1;
            tempMap.push({
              question: item,
              number: questionNumber,
              pageId: item.pageId
            });
          }
          tempMap.push({
            question: item,
            number: undefined,
            pageId: item.pageId
          });
        });
      }
      return tempMap;
    }
  }, {
    key: "renderQuestion",
    value: function renderQuestion(question, response, comment) {
      if (!question) return;
      var number = this.props.settings.oneQuestionAtATime ? this.state.questionNumber : this.getQuestionNumber(question);
      // set any props that were pulled over directly from the QuestionBuilder
      if ('answerRequired' in question) question.required = question.answerRequired;
      if ('displayFormat' in question) question.columns = question.displayFormat;
      if ('displayOrder' in question) question.sortOrder = question.displayOrder.value;
      if ('questionPlaceholder' in question) question.placeholder = question.questionPlaceholder;

      // update other captions
      if (question.otherQuestion && question.otherQuestion.enabled) {
        if (question.otherQuestion.label === 'Other (describe)') question.otherQuestion.label = this.getCaption(_PctySurvey2.otherCaptionKeys.otherText, _PctySurvey2.otherDefaultCaptions.otherText);
        question.otherQuestion.placeholder = this.getCaption(_PctySurvey2.otherCaptionKeys.enterText, _PctySurvey2.otherDefaultCaptions.enterText);
      }

      // update dropdown text
      if (question.typeId === _questionBuilder.QUESTION_TYPE.dropdownList && question.placeholder && question.placeholder === 'Select...') {
        question.placeholder = this.getCaption(_PctySurvey2.otherCaptionKeys.selectValue, _PctySurvey2.otherDefaultCaptions.selectValue);
      }

      // update textfield placeholders
      if (question.typeId === _questionBuilder.QUESTION_TYPE.textField || question.typeId === _questionBuilder.QUESTION_TYPE.multipleText) {
        if (question.placeholder && question.placeholder === 'Enter text') question.placeholder = this.getCaption(_PctySurvey2.otherCaptionKeys.enterText, _PctySurvey2.otherDefaultCaptions.enterText);
        if (question.typeId === _questionBuilder.QUESTION_TYPE.multipleText && !question.placeholder) question.placeholder = this.getCaption(_PctySurvey2.otherCaptionKeys.enterText, _PctySurvey2.otherDefaultCaptions.enterText);
      }

      // update constantsum placeholders
      if (question.typeId === _questionBuilder.QUESTION_TYPE.constantSum) {
        if (!question.placeholder) question.placeholder = this.getCaption(_PctySurvey2.otherCaptionKeys.enterValue, _PctySurvey2.otherDefaultCaptions.enterValue);
      }
      var questionKey = question.id || _uuid.default.v4();
      var validationState = this.getValidationError(question);
      switch (question.typeId) {
        case _questionBuilder.QUESTION_TYPE.title:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.SectionTitle, {
            id: question.id,
            title: question.title,
            includeSectionHeading: question.includeSectionHeading
          })));
        case _questionBuilder.QUESTION_TYPE.paragraph:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.SectionParagraph, {
            id: question.id,
            content: question.content
          })));
        case _questionBuilder.QUESTION_TYPE.video:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, this.props.onGetViewVideoToken ? /*#__PURE__*/_react.default.createElement(_reactQuestion.default.Video, {
            id: question.id,
            title: question.title,
            videoId: question.videoId,
            readOnly: this.props.previewOnly,
            onGetViewVideoToken: this.props.onGetViewVideoToken
          }) : _p || (_p = /*#__PURE__*/_react.default.createElement("p", null, "No video token function specified!"))));
        case _questionBuilder.QUESTION_TYPE.multipleChoice:
        case _questionBuilder.QUESTION_TYPE.trueFalse:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.MultipleChoice, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            options: question.options,
            columns: question.columns,
            otherQuestion: question.otherQuestion,
            sortOrder: question.sortOrder,
            response: response || [],
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            number: number
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
        case _questionBuilder.QUESTION_TYPE.dropdownList:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.DropdownList, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            options: question.options,
            otherQuestion: question.otherQuestion,
            sortOrder: question.sortOrder,
            placeholder: question.placeholder,
            response: response || [],
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            number: number
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
        case _questionBuilder.QUESTION_TYPE.stackRank:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.StackRank, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            options: question.options,
            response: response || [],
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            confirmOrderCaption: this.getCaption(_PctySurvey2.otherCaptionKeys.confirmOrder, _PctySurvey2.otherDefaultCaptions.confirmOrder),
            number: number
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
        case _questionBuilder.QUESTION_TYPE.checkbox:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.Checkbox, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            options: question.options,
            columns: question.columns,
            otherQuestion: question.otherQuestion,
            sortOrder: question.sortOrder,
            response: response,
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            number: number
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
        case _questionBuilder.QUESTION_TYPE.multipleText:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.MultipleText, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            options: question.options,
            sortOrder: question.sortOrder,
            placeholder: question.placeholder,
            response: response || [],
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            number: number
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
        case _questionBuilder.QUESTION_TYPE.constantSum:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.ConstantSum, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            options: question.options,
            sortOrder: question.sortOrder,
            minimumValue: question.minimumValue,
            maximumValue: question.maximumValue,
            targetSumValue: question.targetSumValue,
            enforceTargetSum: question.enforceTargetSum,
            placeholder: question.placeholder,
            response: response || [],
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            allocatedCaption: this.getCaption(_PctySurvey2.otherCaptionKeys.allocated, _PctySurvey2.otherDefaultCaptions.allocated),
            totalCaption: this.getCaption(_PctySurvey2.otherCaptionKeys.total, _PctySurvey2.otherDefaultCaptions.total),
            sumMustEqualCaption: this.getCaption(_PctySurvey2.validationErrorKeys.sumMustEqual, _PctySurvey2.validationErrorDefaultCaptions.sumMustEqual).replace("TARGET_SUM", "".concat(question.targetSumValue)),
            minimumInputCaption: this.getCaption(_PctySurvey2.validationErrorKeys.minimumInputRange, _PctySurvey2.validationErrorDefaultCaptions.minimumInputRange).replace("MINIMUM_INPUT", "".concat(question.minimumValue)),
            maximumInputCaption: this.getCaption(_PctySurvey2.validationErrorKeys.maximumInputRange, _PctySurvey2.validationErrorDefaultCaptions.maximumInputRange).replace("MAXIMUM_INPUT", "".concat(question.maximumValue)),
            minAndMaxInputCaption: this.getCaption(_PctySurvey2.validationErrorKeys.minAndMaxInputRange, _PctySurvey2.validationErrorDefaultCaptions.minAndMaxInputRange).replace("MINIMUM_INPUT", "".concat(question.minimumValue)).replace("MAXIMUM_INPUT", "".concat(question.maximumValue)),
            number: number
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
        case _questionBuilder.QUESTION_TYPE.starRating:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.StarRating, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            starCount: question.starCount,
            response: response || 0,
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            number: number,
            allowComments: question.allowComments,
            commentsPlaceholder: question.commentsPlaceholder,
            comment: comment || "",
            onComment: this.handleOnComment
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
        case _questionBuilder.QUESTION_TYPE.ratingScale:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, /*#__PURE__*/_react.default.createElement(_reactQuestion.default.RatingScale, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            options: question.options,
            minimumRateLabel: question.minimumRateLabel,
            maximumRateLabel: question.maximumRateLabel,
            response: response || 0,
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            number: number,
            allowComments: question.allowComments,
            commentsPlaceholder: question.commentsPlaceholder,
            comment: comment || "",
            onComment: this.handleOnComment
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
        case _questionBuilder.QUESTION_TYPE.textField:
          return /*#__PURE__*/_react.default.createElement("div", {
            key: questionKey,
            className: "pcty-row pcty-padding-bottom"
          }, /*#__PURE__*/_react.default.createElement("div", {
            className: "pcty-col-xs-12"
          }, question.multiLine ? /*#__PURE__*/_react.default.createElement(_reactQuestion.default.MultiLine, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            placeholder: question.placeholder,
            response: response || '',
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            number: number
          }) : /*#__PURE__*/_react.default.createElement(_reactQuestion.default.SingleLine, {
            id: question.id,
            disabled: question.disabled,
            required: question.required,
            scenario: question.scenario,
            question: question.question,
            hint: question.hint,
            placeholder: question.placeholder,
            response: response || '',
            onResponse: this.handleOnResponse,
            readOnly: this.props.previewOnly,
            number: number
          }), !validationState.valid ? /*#__PURE__*/_react.default.createElement("span", {
            className: "pcty-input-footnote pcty-input-validation pcty-error pcty-margin-compact-top"
          }, validationState.errorMessage) : ''));
      }
    }
  }, {
    key: "renderPages",
    value: function renderPages() {
      var _this10 = this;
      var activePageIndex = this.state.pages.findIndex(function (x) {
        return x === _this10.state.activePageId;
      });
      return (
        // show the pages if we're allowed to and if there's more than 1
        this.props.settings.displayQuestionsInPages && !this.props.settings.oneQuestionAtATime && this.props.settings.displayPageNumbers && this.state.pages.length > 1 && /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-row pcty-padding-horizontal pcty-padding-vertical"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "pcty-col-xs-12"
        }, this.state.pages.map(function (page, index) {
          return index === activePageIndex ? /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
            key: page,
            id: "btn-page-".concat(index),
            className: "pcty-padding-left pcty-padding-right",
            onClick: function onClick() {
              return _this10.onSetActivePage(page, index);
            }
          }, "Page ".concat(index + 1)) : /*#__PURE__*/_react.default.createElement(_button.BorderlessButton, {
            key: page,
            id: "btn-page-".concat(index),
            className: "pcty-padding-left pcty-padding-right",
            onClick: function onClick() {
              return _this10.onSetActivePage(page, index);
            }
          }, "Page ".concat(index + 1));
        })))
      );
    }
  }, {
    key: "getQuestionsOnPage",
    value: function getQuestionsOnPage(activePageId, questionNumberPageMap) {
      // filter the questions by pageId if enabled
      var questionsToDisplay = [];
      if (questionNumberPageMap) {
        if (this.props.settings.displayQuestionsInPages && !this.props.settings.oneQuestionAtATime && !(0, _utilsValue.isNullOrEmpty)(activePageId)) {
          questionsToDisplay = questionNumberPageMap.filter(function (x) {
            return x.pageId === activePageId;
          }).map(function (item) {
            return item.question;
          });
        }
      }
      return questionsToDisplay;
    }
  }, {
    key: "getQuestionsToDisplay",
    value: function getQuestionsToDisplay(activePageId) {
      var _this11 = this;
      var questions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
      var newResponse = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;
      var responses = (0, _toConsumableArray2.default)(this.props.responses || []);

      // update the response if newResponse is specified!
      if (newResponse) {
        var responseIndex = (0, _findIndex.default)(responses, function (x) {
          return x.id === newResponse.id;
        });
        if (responseIndex > -1) {
          responses = (0, _utilsArray.removeAt)(responses, responseIndex);
        }
        responses.push(newResponse);
      }

      // filter the questions by pageId if enabled (MUST do it without the map!)
      var questionsToDisplay = questions || this.props.questions || [];
      if (this.props.settings.displayQuestionsInPages && !this.props.settings.oneQuestionAtATime && !(0, _utilsValue.isNullOrEmpty)(activePageId)) {
        questionsToDisplay = questionsToDisplay.filter(function (x) {
          return x.pageId === activePageId;
        });
      }

      // filter the questions by conditional logic if present
      if (questionsToDisplay && questionsToDisplay.length > 0) {
        var conditionalQuestions = questionsToDisplay.filter(function (x) {
          return !(0, _utilsValue.isNullOrEmpty)(x.visibleIf);
        });
        conditionalQuestions.map(function (item) {
          if (!(0, _PctySurvey3.isConditionalCriteriaMet)(_this11.props.questions, responses, item.visibleIf)) {
            var questionIndex = (0, _findIndex.default)(questionsToDisplay, function (x) {
              return x.id === item.id;
            });
            if (questionIndex >= 0 && questionIndex < questionsToDisplay.length) {
              questionsToDisplay = (0, _utilsArray.removeAt)(questionsToDisplay, questionIndex);
            }
          }
        });
      }
      return questionsToDisplay;
    }
  }, {
    key: "renderAllQuestions",
    value: function renderAllQuestions() {
      var _this12 = this;
      if (!this.props.previewOnly && this.state.questionIndex < 0 && !!this.props.renderSplash) {
        return this.renderSplash();
      }
      var questionsToDisplay = this.getQuestionsToDisplay(this.state.activePageId);
      var requiredQuestionIndicator = this.getCaption(_PctySurvey2.validationErrorKeys.requiredQuestionIndicator, _PctySurvey2.validationErrorDefaultCaptions.requiredQuestionIndicator);
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, this.renderPages(), /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-row pcty-margin-none pcty-padding-horizontal pcty-survey-questions"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-col-xs-12"
      }, !this.props.previewOnly && /*#__PURE__*/_react.default.createElement("div", {
        className: "pcty-required-indicator"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "pcty-answer-required",
        style: {
          fontSize: '18px'
        }
      }, "*"), " ", requiredQuestionIndicator), this.state.questionOrder.map(function (id, index) {
        var question = questionsToDisplay.find(function (x) {
          return x.id === id;
        });
        var response = (0, _PctySurvey.getResponse)(question, _this12.props.responses);
        var comment = (0, _PctySurvey.getComment)(question, _this12.props.responses);
        return _this12.renderQuestion(question, response, comment);
      }))));
    }
  }, {
    key: "getCaption",
    value: function getCaption(key, defaultCaption) {
      var caption = defaultCaption;
      if (this.props.settings && this.props.settings.captions) {
        var item = this.props.settings.captions.find(function (x) {
          return x.id === key;
        });
        caption = item && item.value ? item.value : defaultCaption;
      }
      return caption;
    }
  }, {
    key: "onSetActivePage",
    value: function onSetActivePage(pageId, index) {
      // find the page the selected and set it to be the active one
      var activePageIndex = this.state.pages.findIndex(function (x) {
        return x === pageId;
      });
      var activePageId = this.state.pages[activePageIndex];
      if (activePageIndex >= 0 && activePageIndex === index) {
        this.setState({
          activePageId: activePageId
        });
      }
    }
  }, {
    key: "getQuestionsRemaining",
    value: function getQuestionsRemaining(activePageId, questionNumberPageMap) {
      var _this13 = this;
      var questionsRemaining = 0;
      if (questionNumberPageMap && activePageId) {
        if (this.props.settings.displayQuestionsInPages && !this.props.settings.oneQuestionAtATime && !(0, _utilsValue.isNullOrEmpty)(activePageId)) {
          var pageIndex = this.state.pages.findIndex(function (x) {
            return x === _this13.state.activePageId;
          });

          // filter the questions by pageId logic if present; if no questions, goto prev one
          while (pageIndex < this.state.pages.length) {
            questionsRemaining += this.getQuestionsOnPage(this.state.pages[pageIndex], questionNumberPageMap).length;
            pageIndex += 1;
          }
        }
      }
      return questionsRemaining;
    }
  }, {
    key: "renderActions",
    value: function renderActions(location) {
      var _this14 = this;
      var hideStartSurvey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$state = this.state,
        question = _this$state.question,
        questionIndex = _this$state.questionIndex,
        response = _this$state.response;
      var activePageIndex = this.state.pages.findIndex(function (x) {
        return x === _this14.state.activePageId;
      });
      var numQuestionsOnPage = this.getQuestionsOnPage(this.state.activePageId, this.state.questionNumberPageMap).length;
      var pageHasQuestions = numQuestionsOnPage > 0;
      var isOnFirstPage = activePageIndex === 0;
      var totalQuestionsRemaining = this.getQuestionsRemaining(this.state.activePageId, this.state.questionNumberPageMap);
      var isOnLastPage = activePageIndex === this.state.pages.length - 1 || totalQuestionsRemaining - numQuestionsOnPage === 0;
      if (this.props.questions.length === 0 || questionIndex >= this.props.questions.length) return null;
      if (this.state.questionIndex < 0 && !!this.props.renderSplash) {
        return !hideStartSurvey ? /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
          onClick: this.onClickStart,
          id: "btn-start-survey-".concat(location)
        }, "Start Survey") : null;
      }
      var previousButton = null;
      var nextButton = null;
      var completeButton = null;
      var disabled = true;
      if (this.props.settings.oneQuestionAtATime) {
        disabled = this.isQuestionTypeAnswerable(question) && (0, _utilsValue.isNullOrEmpty)(response);
      } else {
        disabled = false;
      }
      if (this.props.settings.displayQuestionsInPages && !this.props.settings.oneQuestionAtATime && this.state.pages.length > 1) {
        previousButton = !isOnFirstPage ? /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
          onClick: this.onClickPreviousPage,
          id: "btn-previous-page-".concat(location)
        }, this.getCaption("SurveyDetails.previousPage", "Previous Page")) : null;
        completeButton = !this.props.settings.hideComplete && (isOnLastPage || !pageHasQuestions) ? /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
          onClick: this.onClickComplete,
          disabled: disabled,
          id: "btn-submit-survey-".concat(location)
        }, this.getCaption("SurveyDetails.complete", "Complete")) : null;
        nextButton = completeButton === null && !isOnLastPage ? /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
          onClick: this.onClickNextPage,
          disabled: disabled,
          id: "btn-next-page-".concat(location)
        }, this.getCaption("SurveyDetails.nextPage", "Next Page")) : null;
      } else {
        if (!this.props.settings.oneQuestionAtATime) {
          return !this.props.settings.hideComplete ? /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
            id: "btn-submit-survey-".concat(location),
            onClick: this.onClickComplete
          }, this.getCaption("SurveyDetails.complete", "Complete")) : null;
        }
        previousButton = this.props.settings.backwardMovement && this.props.settings.oneQuestionAtATime && questionIndex !== 0 ? /*#__PURE__*/_react.default.createElement(_button.SecondaryButton, {
          onClick: this.onClickPreviousQuestion,
          id: "btn-previous-question-".concat(location)
        }, "Previous Question") : null;
        completeButton = questionIndex + 1 === this.props.questions.length ? /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
          onClick: this.onClickComplete,
          disabled: disabled,
          id: "btn-submit-survey-".concat(location)
        }, this.getCaption("SurveyDetails.complete", "Complete")) : null;
        nextButton = completeButton === null ? /*#__PURE__*/_react.default.createElement(_button.PrimaryButton, {
          onClick: this.onClickNextQuestion,
          disabled: disabled,
          id: "btn-next-question-".concat(location)
        }, "Next Question") : null;
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, completeButton, nextButton, previousButton);
    }
  }]);
  return PctySurvey;
}(_react.Component);
PctySurvey.propTypes = {
  /** The id for the component. */
  id: _propTypes.default.string.isRequired,
  /** Whether the component is in preview-only mode with no user-interaction. */
  previewOnly: _propTypes.default.bool.isRequired,
  /** The display name for the survey. */
  name: _propTypes.default.string.isRequired,
  /** An array of questions that are output from the @pcty/react-question-builder */
  questions: _propTypes.default.array.isRequired,
  /** A settings object contains the configuration of a survey. */
  settings: _propTypes.default.shape({
    /** Whether the component should display the questions in order. */
    questionsInOrder: _propTypes.default.bool.isRequired,
    /** Whether the component should display only one question at a time. */
    oneQuestionAtATime: _propTypes.default.bool.isRequired,
    /** Whether the component should allow backward movement through the form. */
    backwardMovement: _propTypes.default.bool.isRequired,
    /** Whether the component should display the header and its sub-components. */
    hideHeader: _propTypes.default.bool.isRequired,
    /** Whether the component should display the footer and its sub-components. */
    hideFooter: _propTypes.default.bool.isRequired,
    /** Whether the component should display the Complete button. */
    hideComplete: _propTypes.default.bool.isRequired,
    /** Whether the component should handle paging and display the paging controls. */
    displayQuestionsInPages: _propTypes.default.bool.isRequired,
    /** Whether the component should display the action buttons inline below the questions. */
    useInlineActions: _propTypes.default.bool.isRequired,
    /** Whether the component should display the numbered page buttons above the questions. */
    displayPageNumbers: _propTypes.default.bool.isRequired,
    /** Whether the component should display the Decline/OptOut action button. */
    allowDecline: _propTypes.default.bool.isRequired,
    /** Whether the component should display the Cancel action button. */
    allowCancel: _propTypes.default.bool.isRequired,
    /** Whether the component should display the Save Draft action button. */
    allowSaveDraft: _propTypes.default.bool.isRequired,
    /** Determines the state of the opt out button, either disabled or not. True indicates that it will be disabled */
    isOptOutButtonDisabled: _propTypes.default.bool,
    captions: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    }))
  }).isRequired,
  /** An array of response objects that are output from the PctySurvey component. */
  responses: _propTypes.default.array,
  /** Render function to display a splash screen at the beginning of the survey. */
  renderSplash: _propTypes.default.func,
  /** Callback function that receives response information each time a user interacts with a question. */
  onResponse: _propTypes.default.func.isRequired,
  /** Callback function to get notified that the survey is now complete. */
  onComplete: _propTypes.default.func.isRequired,
  /** Callback function for when the Back button in the content header is clicked. */
  onBack: _propTypes.default.func,
  /** Callback function for when the Decline/Opt-Out button in the inline-actions area is clicked. */
  onDecline: _propTypes.default.func,
  /** Callback function for when the Cance button in the inline-actions area is clicked. */
  onCancel: _propTypes.default.func,
  /** Callback function for when the Save Draft button in the inline-actions area is clicked. */
  onSaveDraft: _propTypes.default.func,
  /** Callback function for when a Video token is requested. */
  onGetViewVideoToken: _propTypes.default.func,
  /** Callback function that received comment information each time a user interacts with a questions comment. */
  onComment: _propTypes.default.func.isRequired
};
PctySurvey.defaultProps = {
  responses: [],
  previewOnly: false,
  settings: {
    questionsInOrder: true,
    oneQuestionAtATime: false,
    backwardMovement: false,
    hideHeader: true,
    hideFooter: true,
    hideComplete: false,
    displayQuestionsInPages: true,
    useInlineActions: true,
    displayPageNumbers: false,
    allowDecline: false,
    allowCancel: false,
    allowSaveDraft: false,
    isOptOutButtonDisabled: false
  }
};
var getQuestion = function getQuestion(questions, questionOrder, questionIndex) {
  return questions.find(function (x) {
    return x.id === questionOrder[questionIndex];
  });
};
var actionLocation = {
  HEADER: 'header',
  FOOTER: 'footer',
  INLINE: 'inline'
};
var getDefaultValidationState = function getDefaultValidationState() {
  return {
    valid: true,
    errorMessage: ''
  };
};
var _default = exports.default = PctySurvey;